<template lang="pug">
div
  el-row
    el-col(:span="24")
      app-resumo-cadastrante(:cadastrante="cadastro.cadastrante")
      app-resumo-interessado(
        :interessado="cadastro.interessado",
        :hasConjuge="true"
        :idCadastro="idCadastro"
      )
      resumo-imovel(:imovel="cadastro.imovel", :idCadastro="idCadastro")
      app-resumo-geo(:geo="cadastro.georreferenciamento", :idCadastro="idCadastro")
</template>
<script>
import AppResumoCadastrante from '@/components/resumo/AppResumoCadastrante'
import AppResumoInteressado from '@/components/resumo/AppResumoInteressado'
import ResumoImovel from './ResumoImovel'
import AppResumoGeo from '@/components/resumo/AppResumoGeo.vue'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    ResumoImovel,
    AppResumoGeo
  },

  props: ['cadastro', 'idCadastro']
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/components/Resumo.vue